<!-- <fieldset [formGroup]="maintenanceSummary"> -->
<!--
  employeeId:"110823"
  firstName:"Rachel"
  id:"3258310"
  lastName:"Horton"
  role:"Clinical"
-->
<fieldset>
  <legend>Flight Crew</legend>
  <div data-row-span="12">
    <div data-field-span="4">
      <label>Add Crew Member</label>
      <fl-flight-crew-member-select
        [flightCrew]="flightCrew"
        (crewSelected)="emitSelect($event)"
      ></fl-flight-crew-member-select>
    </div>
    <div data-field-span="8">
      <label>Crew</label>
      <div>
        <mat-chip-list selectable="false">
          <mat-chip *ngFor="let m of sortCrewMembers(flightCrew.value)" selected="true">
            {{ m.firstName }} {{ m.lastName }}
            <small>({{ crewRoleDisplay(m.role) }})</small>
            <button mat-icon-button class="closeButton" (click)="removeMember(m)">
              <mat-icon class="mat-18">close</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div>
</fieldset>
